import React, { useState, useMemo } from "react";
import { FaCheckCircle } from "react-icons/fa";
import Sectionbreak from "./Sectionbreak";
import { projects } from "../constants/projects";
import { Link } from "react-router-dom";

function Projects({ itemsPerPage = 6 }) {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(projects.length / itemsPerPage);

  const visibleProjects = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return projects.slice(start, start + itemsPerPage);
  }, [currentPage, itemsPerPage]);

  return (
    <section id="projects" className="py-20 px-6 bg-gray-50">
      <Sectionbreak
        title="Featured"
        highlight="Projects"
        description="Explore some of our completed and ongoing developments that blend design, innovation, and impact."
      />

      <div className="max-w-7xl mx-auto space-y-16">
        {visibleProjects.map((project, index) => (
          <Link
            key={index}
            to={`/projects/${project.slug}`}
            className={`block group bg-white rounded-2xl overflow-hidden 
              shadow-sm hover:shadow-md transition
              ${index % 2 !== 0 ? "md:flex-row-reverse" : ""}
            `}
          >
            <div className="flex flex-col md:flex-row">
              {/* Image */}
              <div className="md:w-1/2 h-64 md:h-auto overflow-hidden">
                <img
                  src={project.coverImage}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 
                    group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="md:w-1/2 p-8 flex flex-col justify-center">
                <h3 className="text-2xl font-bold text-teal-700 mb-2 group-hover:text-teal-800 transition">
                  {project.title}
                </h3>

                <p className="text-sm text-gray-500 mb-5">
                  {project.location} — {project.date}
                </p>

                <ul className="space-y-3 mb-6">
                  {project.highlights.map((item, idx) => (
                    <li key={idx} className="flex items-start text-gray-700">
                      <FaCheckCircle className="text-teal-500 mt-1 mr-2" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* Visual CTA (no extra link needed) */}
                <span
                  className="mt-auto inline-flex w-fit items-center gap-2 
                    bg-teal-50 text-teal-700 border border-teal-100 
                    px-6 py-2 rounded-md
                    transition group-hover:bg-teal-100"
                >
                  View Project →
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>


      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="mt-16 flex justify-center gap-3">
          {Array.from({ length: totalPages }).map((_, i) => {
            const page = i + 1;
            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition
                  ${
                    currentPage === page
                      ? "bg-teal-600 text-white"
                      : "bg-teal-50 text-teal-700 hover:bg-teal-100"
                  }`}
              >
                {page}
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}

export default Projects;
